import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_WEB_BOARD_REPLY,
  GET_WEB_BOARD_REPLY_REPLIES,
  GET_WEB_BOARD_REPLY_REPLIES_BY_FILTER,
  ADD_WEB_BOARD_REPLY,
  UPDATE_WEB_BOARD_REPLY,
  DELETE_WEB_BOARD_REPLY,
} from '../../../../queries/modules/web-board/web-board-reply';

export async function getWebBoardReplyReplies(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARD_REPLY_REPLIES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setWebBoardReplyReplies', data.getWebBoardReplyReplies);
      context.commit('setSuccess', null);
      return data.getWebBoardReplyReplies
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getWebBoardReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARD_REPLY,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getWebBoardReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getWebBoardReplyRepliesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARD_REPLY_REPLIES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setWebBoardReplyReplies', data.getWebBoardReplyRepliesByFilter);
      context.commit('setSuccess', null);
      return data.getWebBoardReplyRepliesByFilter
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addWebBoardReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_WEB_BOARD_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const webBoardReplies = [...context.state.webBoardReplies];
      webBoardReplies.unshift(data.addWebBoardReply);
      context.commit('setWebBoardReplies', webBoardReplies);
      context.commit('setSuccess', newItemSuccess(data.addWebBoardReply.replyMessage));

      return data.addWebBoardReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateWebBoardReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_WEB_BOARD_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoardReplies.findIndex(item => item.id === data.updateWebBoardReply.id);
      const webBoardReplies = [
        ...context.state.webBoardReplies.slice(0, index),
        data.updateWebBoardReply,
        ...context.state.webBoardReplies.slice(index + 1)
      ];
      context.commit('setWebBoardReplies', webBoardReplies);
      context.commit('setSuccess', updateItemSuccess(data.updateWebBoardReply.replyMessage));

      return data.updateWebBoardReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteWebBoardReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_WEB_BOARD_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.webBoardReplies.findIndex(item => item.id === data.deleteWebBoardReply.id);
      const webBoardReplies = [
        ...context.state.webBoardReplies.slice(0, index),
        ...context.state.webBoardReplies.slice(index + 1)
      ];
      context.commit('setWebBoardReplies', webBoardReplies);
      context.commit('setSuccess', deleteItemSuccess(data.deleteWebBoardReply.replyMessage));

      return data.deleteWebBoardReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

